// extracted by mini-css-extract-plugin
export var container = "_3l-0";
export var icon = "_3l-1";
export var text = "_3l-2";